import React, {
  useState,
  useCallback,
  useContext,
} from 'react';
import format from 'string-template';

import MealPlanContext from '../../../../../../context/MealPlanContext';
import useToast from '../../../../../../hooks/useToast';
import RadioButtonGroup from '../../../../../../components/RadioButtonGroup';
import {
  StyledTitledActionContainerSection,
  SettingContainer,
  StyledTypography,
} from '../styles';

import {
  ToggleOption,
  ToggleSetting,
} from './utils';
import texts from './texts';

const toggleOptions = (setting) => Object.values(ToggleOption).map((option) => ({
  label: texts.button[setting][option],
  value: option,
}));

const AutomationToggles = () => {
  const {
    mealPlanConfig,
    saveMealPlanConfig,
  } = useContext(MealPlanContext);

  const [toggleSettings, setToggleSettings] = useState({
    [ToggleSetting.AUTO_ASSIGNMENT]: mealPlanConfig?.[ToggleSetting.AUTO_ASSIGNMENT]
      ? ToggleOption.ENABLE
      : ToggleOption.DISABLE,
    [ToggleSetting.AUTO_REFRESH]: mealPlanConfig?.[ToggleSetting.AUTO_REFRESH]
      ? ToggleOption.ENABLE
      : ToggleOption.DISABLE,
  });

  const { showToast } = useToast();

  const handleToggle = useCallback(async (setting, value) => {
    try {
      setToggleSettings((prevState) => ({
        ...prevState,
        [setting]: value,
      }));

      await saveMealPlanConfig({ [setting]: value === ToggleOption.ENABLE });
      showToast(texts.saved);
    } catch (error) {
      showToast(format(texts.error, { error: error.message ?? 'Unknown error' }), { error: true });
    }
  }, [
    saveMealPlanConfig,
    showToast,
  ]);

  return (
    <StyledTitledActionContainerSection>
      {Object.values(ToggleSetting).map((setting, index) => (
        <SettingContainer key={setting} $top={index === 0}>
          <StyledTypography>{texts.description[setting]}</StyledTypography>
          <RadioButtonGroup
            options={toggleOptions(setting)}
            selectedOption={toggleSettings[setting]}
            onOptionChange={(value) => handleToggle(setting, value)}
          />
        </SettingContainer>
      ))}
    </StyledTitledActionContainerSection>
  );
};

export default AutomationToggles;
